import { SimpleTableBase } from '@core/components/Table';
import { TableActionButtonDelete, TableActionButtonEdit } from '@core/components/TableAction';
import TableActionContainer from '@core/components/TableAction/TableActionContainer';
import { permissaoUtils } from '@core/util/permissaoUtil';
import { formatCNPJ, formatCPF, formatTELEFONE } from '@format';
import React, { useContext } from 'react';
import { VendedorContext } from '../../VendedorContext';
import { vendedorModais } from '../modal/vendedorModais';
import VendedorFab from '../VendedorFab';

const VendedorTable = ({ fetchVendedores, fetchVendedor, onDelete }) => {
  const [vendedores] = useContext(VendedorContext).vendedores;
  const [selecao, setSelecao] = useContext(VendedorContext).selecao;
  const [loading] = useContext(VendedorContext).loading;
  const [, setModal] = useContext(VendedorContext).modal;
  const [, setPage] = useContext(VendedorContext).page;
  const [, setSize] = useContext(VendedorContext).size;
  const [totalElements] = useContext(VendedorContext).totalElements;
  const [tipoSelecao, setTipoSelecao] = useContext(VendedorContext).tipoSelecao;

  const handleOpenModalVisualizar = async (vendedor) => {
    await fetchVendedor(vendedor.id);
    setModal(vendedorModais.visualizacaoVendedor);
  };

  const handleOpenModalEditar = async (vendedor) => {
    await fetchVendedor(vendedor.id);
    setModal(vendedorModais.cadastroVendedor);
  };

  const vendedorColumnDefs = [
    {
      title: 'Nome',
      name: 'pessoa.nome',
      sortingEnabled: true,
      getCellValue: (vendedor) => {
        return vendedor.nome;
      },
    },
    {
      title: 'Razão social',
      name: 'pessoa.pessoaJuridica.razaoSocial',
      sortingEnabled: true,
      getCellValue: (vendedor) => {
        return vendedor.razaoSocial;
      },
    },
    {
      title: 'CPF/CNPJ',
      name: 'pessoa.cpfCnpj',
      sortingEnabled: true,
      hideTooltip: true,
      getCellValue: (vendedor) => {
        if (vendedor.cpf) {
          return formatCPF(vendedor.cpf);
        }
        if (vendedor.cnpj) {
          return formatCNPJ(vendedor.cnpj);
        }
      },
    },
    {
      title: 'Telefone principal',
      name: 'pessoa.contatos.numero',
      hideTooltip: true,
      sortingEnabled: true,
      getCellValue: (vendedor) => {
        if (vendedor.telefonePrincipal) {
          return formatTELEFONE(vendedor.telefonePrincipal);
        }
      },
    },
    {
      name: '',
      title: '',
      sortingEnabled: false,
      align: 'left',
      width: 125,
      getCellValue: (vendedor) => (
        <TableActionContainer>
          {permissaoUtils.vendedor().editar && (
            <TableActionButtonEdit onClick={() => handleOpenModalEditar(vendedor)} />
          )}
          {permissaoUtils.vendedor().excluir && (
            <TableActionButtonDelete onClick={() => onDelete({ ids: [vendedor], q: '', tipoSelecao: 'NENHUM' })} />
          )}
        </TableActionContainer>
      ),
    },
  ];

  return (
    <>
      <SimpleTableBase
        getRowId={(row) => row}
        columns={vendedorColumnDefs}
        rows={vendedores}
        fetchData={fetchVendedores}
        loading={loading}
        onRowClick={handleOpenModalVisualizar}
        defaultSorting={[{ columnName: 'pessoa.nome', direction: 'asc' }]}
        totalCount={totalElements}
        onCurrentPageChange={(params) => {
          setPage(params);
        }}
        onPageSizeChange={(params) => {
          setSize(params);
        }}
        selectionType={tipoSelecao}
        onSelectionTypeChange={(tipo) => {
          setTipoSelecao(tipo);
        }}
        fetchOnCreate
        pageType="async"
        selection={selecao}
        onSelectionChange={setSelecao}
        onSortingChange={(params) => console.log(params)}
        onLoadingChange={(params) => console.log('loading change', params)}
        searchBy=""
      />
      {(permissaoUtils.vendedor().cadastrar || permissaoUtils.vendedor().excluir) && (
        <VendedorFab selected={selecao.length} onDelete={onDelete} fetchVendedor={fetchVendedor} />
      )}
    </>
  );
};

export default VendedorTable;
